import React from "react";
import { Badge } from "react-bootstrap";
import { getGreekCurrencyFormat } from "../../../../../_helpers/commonFunctions";
import "./aidraftline.css";

const AIDraftLine = ({ ai_drafts, onAIDraftChange, selectedIndex }) => {
    return (
        <React.Fragment>
            <div className={"text-center mt-1"}>
                <h5>Έχουν εντοπιστεί πολλαπλές αντικριζόμενες εγγραφές</h5>
            </div>
            <div className="d-flex overflow-auto py-2 px-1 ai-draft-line-container">
                {ai_drafts.map((o, idx) => (
                    <div
                        key={o.id || idx}
                        onClick={() => onAIDraftChange(o, idx)}
                        className={`card flex-shrink-0 me-2 mb-1 p-3 text-center shadow-sm ai-draft-line-card ${
                            selectedIndex === idx ? "active" : ""
                        }`}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Badge bg={selectedIndex === idx ? "primary" : "secondary"}>
                                Εγγραφή #{idx + 1}
                            </Badge>
                        </div>

                        <div
                            className="fw-bold text-start ai-draft-line-title"
                            title={o.ai_document?.clientName || o.ai_document?.supplierName}
                        >
                            {o.ai_document?.clientName || o.ai_document?.supplierName}
                        </div>

                        <div className="text-muted text-start mt-1" style={{ fontSize: "0.85rem", whiteSpace: "normal" }}>
                            {getGreekCurrencyFormat(o.ai_document?.amount)}
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
}

export default AIDraftLine;